import React from 'react';
import { CommonConfigContext, useCommonConfigLogic, CommonConfigState } from '../store/commonConfigStore';

interface CommonConfigProviderProps {
  children: React.ReactNode;
}

export const CommonConfigProvider: React.FC<CommonConfigProviderProps> = ({ children }) => {
  const configData = useCommonConfigLogic();

  return (
    <CommonConfigContext.Provider value={configData as CommonConfigState | null}>
      {children}
    </CommonConfigContext.Provider>
  );
};







